import {transformFiltersForStoreToFilter} from 'utils/filters';
import {transformSortForStoreToSortForUrl} from 'utils/sort';
import {
  transformPaginationForStoreToPaginationForApi,
  transformCursorPaginationForStoreToPaginationForApi,
  PaginationForStore,
  CursorPaginationForStore
} from 'utils/pagination';

export const STORE_PARAMS_IN_URL = 'urls/STORE_PARAMS_IN_URL';

export const storeFiltersInUrl = ({
  filtersSelector
}: {
  filtersSelector: (store: any) => any;
}) => ({
  type: STORE_PARAMS_IN_URL,
  payload: {
    selector: filtersSelector,
    builder: transformFiltersForStoreToFilter
  }
});

export const storeSortInUrl = ({sortSelector}) => ({
  type: STORE_PARAMS_IN_URL,
  payload: {
    selector: sortSelector,
    builder: transformSortForStoreToSortForUrl
  }
});

export const storePaginationInUrl = ({
  paginationSelector
}: {
  paginationSelector: (store: any) => PaginationForStore;
}) => ({
  type: STORE_PARAMS_IN_URL,
  payload: {
    selector: paginationSelector,
    builder: transformPaginationForStoreToPaginationForApi
  }
});

export const storeCursorPaginationInUrl = ({
  paginationSelector
}: {
  paginationSelector: (store: any) => CursorPaginationForStore;
}) => ({
  type: STORE_PARAMS_IN_URL,
  payload: {
    selector: paginationSelector,
    builder: transformCursorPaginationForStoreToPaginationForApi
  }
});

export {default as urlsSaga} from './saga';
